import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import { isPhoneNumber, phoneDesc } from "@/util";
import { AuthTypeMap } from "@/util/type";
import moment from "moment";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default {
  name: "personalprofile",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      info: {},
      page: 1,
      //当前页数
      size: 12,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      list: [],
      evaluationStar: -1,
      level: [{
        text: "好评",
        color: "#54ead4"
      }, {
        text: "中评",
        color: "#3b7ce1"
      }, {
        text: "差评",
        color: "#e75353"
      }],
      activeName: -1,
      tabs: [{
        label: "全部",
        evaluationStar: -1,
        count: 0
      }, {
        label: "好评 ",
        evaluationStar: 0,
        count: 0
      }, {
        label: "中评 ",
        evaluationStar: 1,
        count: 0
      }, {
        label: "差评",
        evaluationStar: 2,
        count: 0
      }]
    });
    onMounted(() => {
      selectBiography();
    });

    //查询个人简介
    const selectBiography = async () => {
      const params = {
        evaluationStar: data.evaluationStar,
        customerId: route.query.customerId,
        page: data.page,
        size: data.size
      };
      data.info = await globalProperties.$api.selectBiography(params);
      data.list = data.info.customerEvaluationVOPage.records;
      data.size = data.info.customerEvaluationVOPage.size;
      data.page = data.info.customerEvaluationVOPage.current;
      data.total = data.info.customerEvaluationVOPage.total;
    };

    //
    const tabChange = evaluationStar => {
      data.evaluationStar = evaluationStar;
      selectBiography();
    };
    const currentChange = page => {
      data.page = page;
      selectBiography();
    };
    return {
      data,
      moment,
      currentChange,
      isPhoneNumber,
      phoneDesc,
      tabChange,
      AuthTypeMap,
      zhCn
    };
  }
};